import { Box, Drawer, IconButton, styled, Typography } from '@mui/material'
import React from 'react'

import { Icon } from '#/components/Icon'

const StyledDrawer = styled(Drawer)({
  '& .MuiDrawer-paper': {
    maxWidth: '100%',
  },
})

const DrawerContainer = styled(Box)({
  height: '100%',
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
})

const DrawerHeader = styled('div')(({ headerColor, hasHeader }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: hasHeader ? '30px 40px 25px' : '30px 40px 0',
  backgroundColor: headerColor,
}))

const DrawerContent = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('xl')]: {
    padding: 10,
  },
  [theme.breakpoints.up('sm')]: {
    padding: '20px 40px',
  },
}))

export default function DrawerBox(props) {
  const {
    pageName,
    title,
    header,
    headerColor,
    children,
    contentStyle,
    width = 500,
    anchor = 'right',
    isOpen,
    onClose,
  } = props

  return (
    <StyledDrawer anchor={anchor} open={isOpen} onClose={onClose}>
      <DrawerContainer style={{ width }}>
        <DrawerHeader headerColor={headerColor} hasHeader={!!header}>
          {header || (
            <div>
              {pageName}
              {title && (
                <Typography variant="h2" sx={{ m: 0 }}>
                  {title}
                </Typography>
              )}
            </div>
          )}
          <IconButton onClick={onClose}>
            <Icon size="large" name="close" />
          </IconButton>
        </DrawerHeader>
        <DrawerContent style={contentStyle}>{children}</DrawerContent>
      </DrawerContainer>
    </StyledDrawer>
  )
}
